import { API_VERSION } from '@/apis/constants';
import { Api } from '@/typings/api';
import { ApiMethod, ApiService, buildUrl } from '@/utils/api';
import Request from '@/utils/Request';

import {
  GetReportCfvEmissionsDataEntryParams,
  GetReportCfvEmissionsDataEntryRes,
  // [PLOP ANCHOR] dtoImport
} from './data-entry.dto';

const request = Request.getInstance().request;

export const getReportCfvEmissionsDataEntryUrl = () =>
  buildUrl({
    service: ApiService.REPORT,
    version: API_VERSION[ApiService.REPORT],
    path: `/cfv/emissions/data_entry`,
  });
// [PLOP ANCHOR] apisUrl

export const getReportCfvEmissionsDataEntry: Api<
  GetReportCfvEmissionsDataEntryParams,
  GetReportCfvEmissionsDataEntryRes
> = (payload) =>
  request({
    url: getReportCfvEmissionsDataEntryUrl(),
    method: ApiMethod.GET,
    params: payload.query,
  });

// [PLOP ANCHOR] apisDefinition
